import httpManager from "../../shared/utils/httpManager";

export async function validateTenantName(body) {
  const options = { isPublic: true };
  const response = await httpManager.post("/customers/validate_workspace_available/", body, options);
  return response.data;
}
